import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import DoneIcon from '@material-ui/icons/Done';
import times from 'lodash/times';

const useStyles = makeStyles((theme) => ({
  heading: {
    marginBottom: theme.spacing(3),
  },
  subheading: {
    fontWeight: 500,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  caption: {
    color: '#AAB5CE',
    paddingLeft: 10,
    paddingRight: 10,
  },
  statuses: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  taskIcon: {
    position: 'relative',
    marginRight: 4,
  },
  chatIcon: {
    'color': '#D2D7E3',
    'opacity': 0.4,
    'fontSize': 32,
    '&.done': {
      color: theme.palette.success.main,
      opacity: 1,
    },
  },
  doneIcon: {
    color: theme.palette.text.secondary,
    fontSize: 14,
    position: 'absolute',
    left: 10,
    top: 5,
  },
}));

const TaskIcon = ({ isDone }) => {
  const classes = useStyles();
  return (
    <div className={classes.taskIcon}>
      <ChatBubbleIcon className={cx(classes.chatIcon, { done: !isDone })} />
      {isDone && <DoneIcon className={classes.doneIcon} />}
    </div>
  );
};

const Sessions = ({ data = [], student }) => {
  const classes = useStyles();
  const isUnlimited = student.product_type === 'pro';
  //extract avaliable and debit from circle_cc and CC
  const circle_cc_total = data?.find((i) => i.credit_type === 'circle_cc')?.available || 0;
  const circle_cc_done = Math.abs(data?.find((i) => i.credit_type === 'circle_cc')?.debit) || 0;


  let cc_total = data.find((i) => i.credit_type === 'cc')?.available || 0;
  let cc_done = Math.abs(data.find((i) => i.credit_type === 'cc')?.debit || 0);


  cc_total = cc_total + circle_cc_total; // total available value of CC and circle_cc
  cc_done = cc_done + circle_cc_done;  //total debit value of CC and circle_cc 



  const circle_hc_total =
    data?.find((i) => i.credit_type === 'circle_hc')?.available || 0;
  const circle_hc_done = Math.abs(
    data?.find((i) => i.credit_type === 'circle_hc')?.debit || 0,
  );
  let hc_total = data.find((i) => i.credit_type === 'hc')?.available || 0;
  let hc_done = Math.abs(data.find((i) => i.credit_type === 'hc')?.debit || 0);
  hc_total = hc_total + circle_hc_total;
  hc_done = hc_done + circle_hc_done;

  const fa_total = data.find((i) => i.credit_type === 'fa')?.available || 0;
  const fa_done = Math.abs(
    data.find((i) => i.credit_type === 'fa')?.debit || 0,
  );

  const cc_essay_total =
    data?.find((i) => i.credit_type === 'cc_essay')?.available || 0;
  const cc_essay_done = Math.abs(
    data?.find((i) => i.credit_type === 'cc_essay')?.debit || 0,
  );
  const hc_essay_total =
    data?.find((i) => i.credit_type === 'hc_essay')?.available || 0;
  const hc_essay_done = Math.abs(
    data?.find((i) => i.credit_type === 'hc_essay')?.debit || 0,
  );

  const fafsa_total =
    data?.find((i) => i.credit_type === 'fafsa')?.available || 0;
  const fafsa_done = Math.abs(
    data?.find((i) => i.credit_type === 'fafsa')?.debit || 0,
  );
  const cssp_total =
    data?.find((i) => i.credit_type === 'css_profile')?.available || 0;
  const cssp_done = Math.abs(
    data?.find((i) => i.credit_type === 'css_profile')?.debit || 0,
  );
  const fafsaCss_total =
    data?.find((i) => i.credit_type === 'fafsa_css')?.available || 0;
  const fafsaCss_done = Math.abs(
    data?.find((i) => i.credit_type === 'fafsa_css')?.debit || 0,
  );

  const expert_total =
    data?.find((i) => i.credit_type === 'expert')?.available || 0;
  const expert_done = Math.abs(
    data?.find((i) => i.credit_type === 'expert')?.debit || 0,
  );

  return (
    <Card>
      <CardContent>
        <Typography className={classes.heading} variant="h5">
          Credits Usage
        </Typography>
        <Grid container spacing={3}>
          {expert_total > 0 && (
            <Grid item md={4}>
              <Typography variant="subtitle1">
                {expert_done}/{expert_total}
              </Typography>
              <Typography paragraph variant="caption">
                Expert Credits
              </Typography>
              {
                <div className={classes.statuses}>
                  {times(expert_total, (i) => (
                    <TaskIcon isDone={i < expert_done} />
                  ))}
                </div>
              }
            </Grid>
          )}
          {cc_total > 0 && (
            <Grid item md={4}>
              <Typography variant="subtitle1">
                {cc_done}/{cc_total}
              </Typography>
              <Typography paragraph variant="caption">
                College Coach
              </Typography>
              {
                <div className={classes.statuses}>
                  {times(cc_total, (i) => (
                    <TaskIcon isDone={i < cc_done} />
                  ))}
                </div>
              }
            </Grid>
          )}
          {hc_total > 0 && (
            <Grid item md={4}>
              <Typography variant="subtitle1">
                {hc_done}/{hc_total}
              </Typography>
              <Typography paragraph variant="caption">
                Head Counselor
              </Typography>
              {
                <div className={classes.statuses}>
                  {times(hc_total, (i) => (
                    <TaskIcon isDone={i < hc_done} />
                  ))}
                </div>
              }
            </Grid>
          )}
          {fa_total > 0 && (
            <Grid item md={4}>
              <Typography variant="subtitle1">
                {fa_done}/{fa_total}
              </Typography>
              <Typography paragraph variant="caption">
                Financial Aid Counselor
              </Typography>
              {
                <div className={classes.statuses}>
                  {times(fa_total, (i) => (
                    <TaskIcon isDone={i < fa_done} />
                  ))}
                </div>
              }
            </Grid>
          )}
          {student.product_type !== 'pro' && (
            <>
              {' '}
              {cc_essay_total > 0 && (
                <Grid item md={4}>
                  <Typography variant="subtitle1">
                    {cc_essay_done}/{isUnlimited ? 'Unlimited' : cc_essay_total}
                  </Typography>
                  <Typography paragraph variant="caption">
                    CC Essay Credits
                  </Typography>
                  {
                    <div className={classes.statuses}>
                      {times(cc_essay_total, (i) => (
                        <TaskIcon isDone={i < cc_essay_done} />
                      ))}
                    </div>
                  }
                </Grid>
              )}
              {student.product_type === 'core' && (
                <>
                  {hc_essay_total > 0 && (
                    <Grid item md={4}>
                      <Typography variant="subtitle1">
                        {hc_essay_done}/
                        {isUnlimited ? 'Unlimited' : hc_essay_total}
                      </Typography>
                      <Typography paragraph variant="caption">
                        HC Essay Credits
                      </Typography>
                      {
                        <div className={classes.statuses}>
                          {times(hc_essay_total, (i) => (
                            <TaskIcon isDone={i < hc_essay_done} />
                          ))}
                        </div>
                      }
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
          {fafsa_total > 0 && (
            <Grid item md={4}>
              <Typography variant="subtitle1">
                {fafsa_done}/{fafsa_total}
              </Typography>
              <Typography paragraph variant="caption">
                FAFSA Credits
              </Typography>
              {
                <div className={classes.statuses}>
                  {times(fafsa_total, (i) => (
                    <TaskIcon isDone={i < fafsa_done} />
                  ))}
                </div>
              }
            </Grid>
          )}
          {cssp_total > 0 && (
            <Grid item md={4}>
              <Typography variant="subtitle1">
                {cssp_done}/{cssp_total}
              </Typography>
              <Typography paragraph variant="caption">
                CSS Profile Credits
              </Typography>
              {
                <div className={classes.statuses}>
                  {times(cssp_total, (i) => (
                    <TaskIcon isDone={i < cssp_done} />
                  ))}
                </div>
              }
            </Grid>
          )}
          {fafsaCss_total > 0 && (
            <Grid item md={4}>
              <Typography variant="subtitle1">
                {fafsaCss_done}/{fafsaCss_total}
              </Typography>
              <Typography paragraph variant="caption">
                FAFSA + CSS Profile Credits
              </Typography>
              {
                <div className={classes.statuses}>
                  {times(fafsaCss_total, (i) => (
                    <TaskIcon isDone={i < fafsaCss_done} />
                  ))}
                </div>
              }
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Sessions;
